<template>
  <div class="user-addresses">
    <div class="address">
      <h5>Private{{ privateIsBilling ? '/Billing' : '' }} Address</h5>
      <user-address :address="private"></user-address>
    </div>
    <div class="address" v-if="!privateIsBilling">
      <h5>Billing Address</h5>
      <user-address :address="billing"></user-address>
    </div>
  </div>
</template>

<style lang="scss">

  $border-color: #d1dbe5;

  .user-addresses {
    border: 1px solid $border-color;
    padding: 20px;
    display: flex;

    .address {
      flex: 1 1 0;

      &:not(:last-child) {
        border-right: 1px dashed $border-color;
        margin-right: 20px;
      }

      & > *:last-child {
        margin-bottom: 0;
      }
    }
  }
</style>

<script>
import UserAddress from './UserAddress'

export default {
  props: ['private', 'billing'],

  components: { UserAddress },

  computed: {
    privateIsBilling () {
      return !this.billing.firstname
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/UserAddresses.vue